import { Helper } from '../Helper';
export class ArrLeftHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitOp(node, 'OVER');
        sb.emitOp(node, 'ARRAYSIZE');
        sb.emitPushInt(node, 0);
        sb.emitOp(node, 'NEWARRAY');
        sb.emitOp(node, 'ROT');
        sb.emitOp(node, 'ROT');
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'GT');
            },
            each: () => {
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICK');
                sb.emitPushInt(node, 4);
                sb.emitOp(node, 'PICK');
                sb.emitPushInt(node, 2);
                sb.emitOp(node, 'PICK');
                sb.emitOp(node, 'PICKITEM');
                sb.emitOp(node, 'APPEND');
                sb.emitOp(node, 'INC');
                sb.emitOp(node, 'SWAP');
            },
            cleanup: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'NIP');
            },
        }));
    }
}

//# sourceMappingURL=ArrLeftHelper.js.map
